/**
 * Poll Message Container
 *
 * Renders a poll attached to a message. Messages only carry the poll's id
 * (audit #6); the full computed poll — options, percentages, the current
 * user's votes, expiry — is fetched by id via `usePoll` (the /polls/:id
 * endpoint), keeping a single source of truth for poll rendering.
 */

import React from 'react';
import { usePoll } from '../../hooks/usePolls';
import { PollDisplay } from './PollDisplay';

interface PollMessageProps {
  pollId: string;
}

export const PollMessage: React.FC<PollMessageProps> = ({ pollId }) => {
  const { data: poll, isLoading, isError } = usePoll(pollId);

  if (isLoading) {
    return (
      <div className="mt-2 animate-pulse rounded-lg border border-gray-200 dark:border-gray-700 p-4">
        <div className="h-4 w-1/2 rounded bg-gray-200 dark:bg-gray-700" />
        <div className="mt-3 space-y-2">
          <div className="h-8 rounded bg-gray-100 dark:bg-gray-800" />
          <div className="h-8 rounded bg-gray-100 dark:bg-gray-800" />
        </div>
      </div>
    );
  }

  if (isError || !poll) {
    return (
      <div className="mt-2 rounded-lg border border-gray-200 dark:border-gray-700 p-3 text-sm text-gray-500 dark:text-gray-400">
        Анкетата не можа да се зареди
      </div>
    );
  }

  return <PollDisplay poll={poll} />;
};
